class MarqueeSlider extends HTMLElement {
  constructor() {
    super();

    this.onMouseEnter = this.onMouseEnter.bind(this);
    this.onMouseLeave = this.onMouseLeave.bind(this);
    this.onMediaChange = this.onMediaChange.bind(this);
  }

  connectedCallback() {
    this.wrappers = [...this.querySelectorAll("[data-marquee-wrapper]")];

    if (!this.wrappers.length) return;

    this.pixelsPerSecond =
      parseFloat(this.dataset.pixelsPerSecond || "50") || 50;
    this.mediaQuery = window.matchMedia("(min-width: 1024px)");
    this.mediaQuery.addEventListener("change", this.onMediaChange);

    this.applyMode();
  }

  disconnectedCallback() {
    this.mediaQuery?.removeEventListener("change", this.onMediaChange);
    this.stopMarquee();
  }

  onMediaChange() {
    this.applyMode();
  }

  applyMode() {
    if (this.mediaQuery.matches) {
      this.startMarquee();
      return;
    }

    this.stopMarquee();
  }

  startMarquee() {
    const build = () => {
      if (this.timeline || !this.mediaQuery.matches) return true;
      if (typeof gsap === "undefined") return false;

      const width = this.wrappers[0].offsetWidth;
      if (!width) return false;

      if (this.hasAttribute("data-pause-on-hover")) {
        this.addEventListener("mouseenter", this.onMouseEnter);
        this.addEventListener("mouseleave", this.onMouseLeave);
      }

      this.timeline = gsap.timeline({
        repeat: -1,
      });

      this.timeline.to(this.wrappers, {
        xPercent: -100,
        duration: width / this.pixelsPerSecond,
        ease: "none",
      });

      return true;
    };

    if (build()) return;

    if (document.readyState === "complete") {
      requestAnimationFrame(build);
      return;
    }

    window.addEventListener("load", build, { once: true });
  }

  stopMarquee() {
    this.timeline?.kill();
    this.timeline = null;
    this.removeEventListener("mouseenter", this.onMouseEnter);
    this.removeEventListener("mouseleave", this.onMouseLeave);

    if (typeof gsap !== "undefined") {
      gsap.set(this.wrappers, { clearProps: "transform" });
    }
  }

  onMouseEnter() {
    this.timeline?.pause();
  }

  onMouseLeave() {
    this.timeline?.resume();
  }
}

customElements.define("marquee-slider", MarqueeSlider);
